export default function Hero() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const counselingAreas = [
    { icon: 'ri-bear-smile-line', label: '유아·아동 상담' },
    { icon: 'ri-palette-line', label: '청소년 상담' },
    { icon: 'ri-user-heart-line', label: '성인 상담' },
    { icon: 'ri-heart-line', label: '부부 상담' },
    { icon: 'ri-home-heart-line', label: '가족 상담' },
    { icon: 'ri-building-4-line', label: '기업 상담' },
  ];

  return (
    <section id="home" className="relative min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/e9ac896b83f72e3a7a6af550b4082039.jpg"
          alt="배경"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/25"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-5 md:px-6 py-28 md:py-24 w-full">
        <div className="max-w-2xl">
          <div className="inline-block px-4 py-1.5 md:px-5 md:py-2 bg-[#A8B5A0]/90 backdrop-blur-sm rounded-full mb-4 md:mb-6">
            <span className="text-white text-[11px] md:text-[13px] font-medium whitespace-nowrap">마음이 쉬어가는 공간</span>
          </div>

          <h1 className="text-2xl md:text-4xl font-bold text-white mb-4 md:mb-6 leading-tight">
            당신의 이야기에<br />귀 기울입니다
          </h1>

          <p className="text-[13px] md:text-[15px] text-white/95 leading-relaxed mb-5 md:mb-8 max-w-xl">
            지친 마음이 안전하게 머무를 수 있는 곳.<br />
            전문적인 상담과 따뜻한 공감으로<br />
            당신의 삶에 다시 희망을 찾아드리겠습니다.
          </p>

          <p className="text-[12px] md:text-[14px] text-white/90 mb-6 md:mb-8">
            유아부터 성인까지, 각 삶의 단계에 맞는 전문적인 심리상담을 제공합니다.
          </p>

          <div className="flex gap-2 md:gap-3">
            <button
              onClick={() => scrollToSection('booking')}
              className="px-5 py-2.5 md:px-8 md:py-3 bg-[#A8B5A0] text-white text-[13px] md:text-[14px] font-semibold rounded-full hover:bg-[#8FA088] transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
            >
              상담 예약하기
            </button>
            <button
              onClick={() => scrollToSection('intro')}
              className="px-5 py-2.5 md:px-8 md:py-3 bg-transparent border-2 border-white text-white text-[13px] md:text-[14px] font-semibold rounded-full hover:bg-white hover:text-[#A8B5A0] transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              센터 둘러보기
            </button>
          </div>

          {/* 모바일 전용 상담 영역 목록 */}
          <div className="md:hidden mt-8 bg-white/15 backdrop-blur-sm rounded-2xl px-5 py-4 border border-white/20">
            <p className="text-white/80 text-[11px] font-semibold tracking-widest uppercase mb-3">상담 프로그램</p>
            <div className="grid grid-cols-2 gap-y-3 gap-x-4">
              {counselingAreas.map((area) => (
                <button
                  key={area.label}
                  onClick={() => scrollToSection('programs')}
                  className="flex items-center gap-2 cursor-pointer group"
                >
                  <div className="w-7 h-7 flex items-center justify-center rounded-full bg-white/20 group-hover:bg-[#A8B5A0]/60 transition-colors flex-shrink-0">
                    <i className={`${area.icon} text-white text-[14px]`}></i>
                  </div>
                  <span className="text-white text-[13px] font-medium leading-tight text-left">{area.label}</span>
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
